import React from 'react'
import { Card, Typography, Row, Col, Space, Collapse, List, Table, Button, Switch } from "antd";
import { MeetingBotVM, MeetingBotVMAssignment } from '../../../models/meeting-bot-vm-interface';
import ParentSize from '@visx/responsive/lib/components/ParentSize';
import { MeetingBotVMState } from '../../../constants/meetingBotVMState';
import CPUUsageChart from './CPUUsageChart';
import moment from 'moment';
import { useHistory } from 'react-router';

const { Title } = Typography

type Props = {
  vmRecord: MeetingBotVM | undefined;
  pageIsLoading: boolean;
  isDetailPage?: boolean;
  isTranscription?: boolean;
  changeAlwaysOn?: (enabled: boolean) => void;
}

const VMDetail: React.FC<Props> = ({
  vmRecord,
  pageIsLoading,
  isDetailPage = false,
  isTranscription = false,
  changeAlwaysOn,
}) => {
  const history = useHistory();

  const columns = [
    {
      title: 'Company Id',
      dataIndex: 'companyId',
      key: 'companyId',
      render: (companyId: number) => {
        return (
          <Button
            type="link"
            href={`/admin/company/${companyId}`}
            onClick={(e) => {
              e.preventDefault();
              history.push(`/admin/company/${companyId}`);
            }}
          >
            {companyId}
          </Button>
        )
      }
    },
    {
      title: 'Bot Id',
      dataIndex: 'botId',
      key: 'botId',
    },
    {
      title: 'Media Id',
      dataIndex: 'mediaId',
      key: 'mediaId',
    },
    {
      title: 'Updated Date',
      dataIndex: 'updateDate',
      key: 'updateDate',
      render: (updateDate: string) => {
        return new Date(updateDate + "Z").toLocaleString()
      }
    },
  ]

  if(isTranscription) {
    columns.push({
      title: 'Assigned Date',
      dataIndex: 'assignDate',
      key: 'assignDate',
      render: (assignDate: string) => {
        return new Date(assignDate + "Z").toLocaleString()
      }
    },)
  }

  const setAssignmentTable = (assignmentList: MeetingBotVMAssignment[] | undefined) => {
    return <Table
      size="small"
      bordered
      dataSource={assignmentList ?? []}
      columns={columns}
    />
  }

  return <Card style={{width: '100%'}}>
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Row>
          <Col flex="auto">
            <Title level={5}>
              <Space direction='horizontal'>
                {isDetailPage ? "" : (
                  <a
                    href={`/admin/skynet/${isTranscription ? `transcription/${vmRecord?.id}` : vmRecord?.id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      history.push(`/admin/skynet/${isTranscription ? `transcription/${vmRecord?.id}` : vmRecord?.id}`)
                    }}
                  >
                    {vmRecord?.deploymentName}
                  </a>)
                }
                <span>{vmRecord?.ipAddress}</span>
                <span className={vmRecord?.enabled ? "primary-text" : "red-text"}>{vmRecord?.enabled ? "Enabled" : "Disabled"}</span>
                <span className={vmRecord?.online ? "primary-text" : "red-text"}>{vmRecord?.online ? "Online" : "Offline"}</span>
              </Space>
            </Title>
          </Col>
          {isDetailPage && (
            <Col>
              <Space direction='horizontal'>
                <span>Always On:</span>
                <Switch
                  title='Always On'
                  checkedChildren="Enabled"
                  unCheckedChildren="Disabled"
                  checked={vmRecord?.alwaysOn}
                  onClick={() => {
                    if(!!changeAlwaysOn)
                      changeAlwaysOn(!vmRecord?.alwaysOn ?? false)
                  }}
                />
              </Space>
            </Col>
          )}
        </Row>
      </Col>
      <Col span={24} style={{ height: 300 }}>
        <ParentSize>
          {({ width, height }) => (
            <CPUUsageChart
              width={width}
              height={height}
              data={vmRecord?.heathList}
              isLoading={pageIsLoading}
              isFullDetail={isDetailPage}
            />
          )}
        </ParentSize>
      </Col>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel
            header={`Pending ${isTranscription ? "Transcriptions" : "Recordings"}: ${vmRecord?.assignmentList.filter(recording => recording.state == MeetingBotVMState.Pending).length}`}
            key="pending"
            //collapsible={(vmRecord?.assignmentList?.filter(recording => recording.state == MeetingBotVMState.Pending)?.length ?? 0) > 0 ? undefined : 'disabled'}
          >
            {setAssignmentTable(vmRecord?.assignmentList?.filter(recording => recording.state == MeetingBotVMState.Pending))}
          </Collapse.Panel>
          <Collapse.Panel
            header={`Active ${isTranscription ? "Transcriptions" : "Recordings"}: ${vmRecord?.assignmentList.filter(recording => recording.state == MeetingBotVMState.Running).length}`}
            key="active"
            //collapsible={(vmRecord?.assignmentList?.filter(recording => recording.state == MeetingBotVMState.Running)?.length ?? 0) > 0 ? undefined : 'disabled'}
          >
            {setAssignmentTable(vmRecord?.assignmentList?.filter(recording => recording.state == MeetingBotVMState.Running))}
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  </Card>
}

export default VMDetail;